
export const AnalyticsPage = () => {
    return (
        <div className="reports content">

            <main className="container">
                <div className="reports__title mb-2">
                    <h2 className="main-title">Analytics</h2>
                </div>
            </main>

        </div>
    )
}
